import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiUrlBuilderService } from '../api-url-builder.service';
import { httpOptions } from '../device/devices-data.service';

@Injectable({
  providedIn: 'root',
})
export class AllCustomerAssetsDataService {
  constructor(
    private httpClient: HttpClient,
    private readonly urlBuilder: ApiUrlBuilderService
  ) {}

  public refreshCache(): Observable<{
    success: boolean;
    id: number;
  }> {
    const url = this.urlBuilder.backendApi('all-customer-assets', 'refresh-cache');
    return this.httpClient.post<{
      success: boolean;
      id: number;
    }>(url, {}, httpOptions);
  }
}
